import { l } from './imports'
import { IV } from './IV'

//https://www.npmjs.com/package/fast-random
// import { random } from 'fast-random'
const random = require('fast-random')

const seed = Date.now()
const r: { nextFloat: () => number; nextInt: () => number } = random(seed)

export function f(min: number, max: number) {
  return min + (max - min) * r.nextFloat()
}

export function i(min: number, max: number) {
  return min + (r.nextInt() % (max - min + 1))
}

export function chance(factor: number) {
  return r.nextFloat() <= factor
}

export function sample<T>(arr: T[]) {
  return l.sample(arr)
}

export function vec(): IV {
  let x = f(-1, 1)
  let y = f(-1, 1)
  // let v = Vec2(x, y)
  // v.normalize()

  return { x, y }
}
